// Dashboard pages
import ListaRelatorios from '@/components/Dashboard/Views/Simulacoes/Relatorios/Lista'
import RelatorioConfinamentoSimples from '@/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Simples/Confinamento/Simples'
import RelatorioConfinamentoCompleto from '@/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Completo/Confinamento/Completo'
import RelatorioPastoSimples from '@/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Simples/Pasto/Simples'
import RelatorioPastoCompleto from '@/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Completo/Pasto/Completo'
import ListaRelatoriosComparativo from '@/components/Dashboard/Views/Simulacoes/Relatorios/Comparativo/Lista'
import ComparativoConfinamentoCompleto from '@/components/Dashboard/Views/Simulacoes/Relatorios/Comparativo/Confinamento/Completo'
import ComparativoConfinamentoSimples from '@/components/Dashboard/Views/Simulacoes/Relatorios/Comparativo/Confinamento/Simples'
import ComparativoPastoSimples from '@/components/Dashboard/Views/Simulacoes/Relatorios/Comparativo/Pasto/Simples'
import ComparativoPastoCompelto from '@/components/Dashboard/Views/Simulacoes/Relatorios/Comparativo/Pasto/Completo'
import RelatorioTempoRealListar from '@/components/Dashboard/Views/Simulacoes/Relatorios/TempoReal/Lista'
import RelatorioTempoReal from '@/components/Dashboard/Views/Simulacoes/Relatorios/TempoReal/Relatorio'

const routes = [
  {
    path: 'consolidado/listar',
    name: 'consolidado-lista',
    component: ListaRelatorios
  },
  {
    path: 'comparativo/listar',
    name: 'comparativo-lista',
    component: ListaRelatoriosComparativo
  },
  {
    path: 'consolidado/confinamento/simples/:id',
    name: 'confinamento-basico-relatorio',
    component: RelatorioConfinamentoSimples
  },
  {
    path: 'consolidado/confinamento/completo/:id',
    name: 'confinamento-avancado-relatorio',
    component: RelatorioConfinamentoCompleto
  },
  {
    path: 'consolidado/pasto/simples/:id',
    name: 'pasto-basico-relatorio',
    component: RelatorioPastoSimples
  },
  {
    path: 'consolidado/pasto/completo/:id',
    name: 'pasto-avancado-relatorio',
    component: RelatorioPastoCompleto
  },
  {
    path: 'comparativo/confinamento/completo/:lista',
    name: 'confinamento-avancado-relatorio-comparativo',
    component: ComparativoConfinamentoCompleto
  },
  {
    path: 'comparativo/confinamento/simples/:lista',
    name: 'confinamento-basico-relatorio-comparativo',
    component: ComparativoConfinamentoSimples
  },
  {
    path: 'comparativo/pasto/simples/:lista',
    name: 'pasto-basico-relatorio-comparativo',
    component: ComparativoPastoSimples
  },
  {
    path: 'comparativo/pasto/completo/:lista',
    name: 'pasto-avancado-relatorio-comparativo',
    component: ComparativoPastoCompelto
  },
  {
    path: 'temporeal/listar',
    name: 'temporeal-listar',
    component: RelatorioTempoRealListar
  },
  {
    path: 'temporeal/relatorio/:data/:lista/:tipo',
    name: 'relatorio-temporeal',
    component: RelatorioTempoReal
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/relatorios.js